import { IconN8N } from 'gatorcomponents';
import { useResize } from '@/hooks/useResize';

import * as Styles from './VpsN8nHighlight.styles';

import React from 'react';
import {
  DivContents,
  DivImg,
  Title,
  WrapperTitle,
  DivText,
  ButtonWrapper,
} from '../Highlight.styles';
import GradientButton from '@/components/Buttons/GradientButton';

const VpsN8nHighlight = ({
  element,
  buttonIsLoading = false,
}) => {
  const windowRect = useResize();
  const { width: windowWidth } = windowRect;
  const mobile = windowWidth < 600;

  return (
    <DivContents id={element.id} key={element.id} data-testid={`highlight-${element.id}`}>
      <DivImg>
        <img
          src={element.image}
          alt="produto em destaque"
        />
      </DivImg>

      <DivText>
        <WrapperTitle>
          <Title data-testid={`title-${element.id}`}>{element.title}</Title>
          <IconN8N color="primaryBlue" />
        </WrapperTitle>

        <Styles.Description data-testid={`description-${element.id}`}>
          {element.description}
          {' '}
          <span>
            {element.descriptionPrefix()}
          </span>
        </Styles.Description>

        <Styles.DescriptionList>
          {element.descriptionList.map(item => (
            <Styles.DescriptionListItem key={item.id}>
              {item.icon}
              {item.text}
            </Styles.DescriptionListItem>
          ))}
        </Styles.DescriptionList>

        <ButtonWrapper>
          <GradientButton
            testId="cta"
            label={element.cta.label}
            variant="quaternary"
            size="lg"
            version="v2"
            width={mobile ? 'full' : 'fit-content'}
            onClick={element.cta.onClick}
            loading={buttonIsLoading}
            disabled={buttonIsLoading}
          />
        </ButtonWrapper>
      </DivText>
    </DivContents>
  );
};

export default VpsN8nHighlight;
